import React from 'react';
import { PointsRange } from '../constants/PointsRange';
import { Results as TestResults } from '../constants/Results';
import { TextDomain } from '../constants/TextDomain';
import { getPointsRange } from '../utils/getPointsRange';
import ScorePoints from './ScorePoints';

interface ResultsProps {
    points: number;
    maxPoints: number;
}

const { __ } = window.wp.i18n;

const Results: React.FC<ResultsProps> = (props) => {
    const { points, maxPoints } = props;

    const range = getPointsRange(points);
    const result = TestResults[range];

    return (
        <div className="result-container section-spacer">
            <div className="info-block text-center">
                <div className="result-title text">{__('Your score is:', TextDomain)}</div>
            </div>
            <div className="info-block">
                <ScorePoints value={points} maxValue={maxPoints} />
            </div>
            <div className="info-block">
                <div className="result-title top-title">{__(result.title, TextDomain)}</div>
            </div>
            {result.description && <div className="info-block small-text">{__(result.description, TextDomain)}</div>}
            <div className="results-bottom small-text">
                {range === PointsRange.First ? (
                    <div>
                        {__(
                            'You probably succeed in following the motto "for a beer with reason". Alcohol is reasonably part of the lifestyle of adults, but does not belong in the hands of drivers or pregnant women. If you are taking any medications, talk to your doctor about whether you can drink them.',
                            TextDomain
                        )}
                    </div>
                ) : (
                    <div>
                        {__(
                            'Alcohol does not belong in the hands of drivers or pregnant women. If you are taking any medications, talk to your doctor about whether you can drink them.',
                            TextDomain
                        )}
                    </div>
                )}
                <div>
                    {__(
                        'According to the World Health Organization, the daily allowable dose of alcohol is up to 40 grams for men and 20 grams for women. This means approximately for men - max. 2 large beers (10 °) per day and for women - max. 1 large beer (10 °) per day.',
                        TextDomain
                    )}
                </div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: __(
                            'Thank you for taking our test. If you would like to contact an expert, do not hesitate to use our <a class="link" href="https://napivosrozumem.cz/poradna">Poradna</a>, or you can also contact the experts from Sananim directly z.ú. on the page <a class="link" href="http://www.drogovaporadna.cz/">www.drogovaporadna.cz</a>',
                            TextDomain
                        ),
                    }}
                />
            </div>
        </div>
    );
};

export default Results;
